/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Error_Missing_Items_Not_OpenInputs */

const en_error_missing_items_not_open = /** @type {(inputs: Error_Missing_Items_Not_OpenInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`This inbound has no missing units waiting for a choice: Logistics has not confirmed them, or the supplier already chose.`)
};

/**
* | output |
* | --- |
* | "This inbound has no missing units waiting for a choice: Logistics has not confirmed them, or the supplier already chose." |
*
* @param {Error_Missing_Items_Not_OpenInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const error_missing_items_not_open = /** @type {((inputs?: Error_Missing_Items_Not_OpenInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Error_Missing_Items_Not_OpenInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_error_missing_items_not_open(inputs)
});